export default {
  data () {
    return {
      lastScrollY: 0,
      scrolled: false,
      scrolledTimer: false,
    }
  },

  mounted () {
    document.addEventListener('scroll', this.onScrollY)
    document.addEventListener('scroll', this.onScrollTimer)
  },

  beforeDestroy () {
    document.removeEventListener('scroll', this.onScrollY)
    document.removeEventListener('scroll', this.onScrollTimer)
  },

  methods: {
    onScrollY () {
      const currScrollY = window.scrollY || document.documentElement.scrollTop

      this.scrolled = this.lastScrollY < currScrollY && currScrollY > 200
      this.lastScrollY = currScrollY
    },

    onScrollTimer () {
      const currScrollY = window.scrollY || document.documentElement.scrollTop

      const pathInCheckout = this.$route.path.split('/').includes('checkout')

      this.scrolledTimer = this.$css.breakpoints.mdAndUp ? pathInCheckout ? currScrollY > 80 : currScrollY > 120 : pathInCheckout ? currScrollY > 80 : this.scrolled
    },
  },
}
